import { useModals } from '@/components/modals/ModalProvider';
import { useForm } from '@/libs/antd/form';
import ANTD_DEFAULT_PROPS from '@/libs/antd/props';
import rule from '@/libs/antd/rules';
import { SiteReport } from '@/libs/fleet-api/services/types';
import { Button, Col, Divider, Form, Input, Row } from 'antd';
import { FC } from 'react';
import { useCCAVisitReportVerificationPage } from './VisitReportVerificationPage';

export const useCCASiteVisitReportDetailForm = () => {
	return useForm<SiteReport<'payload'>>();
};
const CCASiteVisitReportDetail: FC<
	ReturnType<typeof useCCASiteVisitReportDetailForm>
> = ({ form, value, fieldName }) => {
	const { openMapModal } = useModals();
	const { siteReport, surveyInformation } = useCCAVisitReportVerificationPage();

	return (
		<Form
			{...ANTD_DEFAULT_PROPS.FORM}
			name="siteReport"
			form={form}
			labelCol={{
				span: 10,
			}}
			initialValues={
				{
					id: siteReport?.id,
					surveyId: surveyInformation!.id,
					visitPurpose: siteReport?.visitPurpose,
					visitSiteAddress: siteReport?.visitSiteAddress,
					visitSiteLat: siteReport?.visitSiteLat,
					visitSiteLong: siteReport?.visitSiteLong,
					visitLocationAnalysis: siteReport?.visitLocationAnalysis,
					visitVerificationNotes:
						siteReport?.visitDetail.visitVerificationNotes,
					additionalVisitInfo: siteReport?.additionalVisitInfo,
					actionPlan: siteReport?.actionPlan,
				} as SiteReport<'payload'>
			}
		>
			<Form.Item
				name={fieldName('id')}
				noStyle
			/>
			<Form.Item
				name={fieldName('surveyId')}
				noStyle
			/>
			<Form.Item
				name={fieldName('visitPurpose')}
				label="Tujuan Kunjungan"
				labelCol={{
					span: 6,
				}}
				rules={[rule.required()]}
			>
				<Input.TextArea rows={4} />
			</Form.Item>
			<Divider />
			<Form.Item
				label="Lokasi Kunjungan"
				labelCol={{
					span: 6,
				}}
			>
				<Form.Item
					name={fieldName('visitSiteAddress')}
					noStyle
					rules={[rule.required()]}
				/>
				<Form.Item
					name={fieldName('visitSiteLat')}
					noStyle
				/>
				<Form.Item
					name={fieldName('visitSiteLong')}
					noStyle
				/>
				<Row
					gutter={10}
					align="middle"
				>
					<Col flex="auto">
						<Input
							disabled
							value={value?.visitSiteAddress}
						/>
					</Col>
					<Col flex="none">
						<Button
							type="link"
							onClick={() => {
								openMapModal({
									title: 'Lokasi Kunjungan',
									address: value?.visitSiteAddress,
									latitude: value?.visitSiteLat,
									longitude: value?.visitSiteLong,
									onChange: ({ address, center }) => {
										form.setFieldsValue({
											visitSiteAddress: address,
											visitSiteLat: center.lat,
											visitSiteLong: center.lng,
										});
									},
								});
							}}
						>
							<u>Edit Lokasi Kunjungan</u>
						</Button>
					</Col>
				</Row>
			</Form.Item>
			<Divider />
			<Form.Item
				name={fieldName('visitLocationAnalysis')}
				label="Analisa Lokasi Kunjungan"
				labelCol={{
					span: 6,
				}}
				rules={[rule.required()]}
			>
				<Input.TextArea rows={4} />
			</Form.Item>
			<Divider />
			<Form.Item
				name={fieldName('additionalVisitInfo')}
				label="FRM Notes"
				labelCol={{
					span: 6,
				}}
			>
				{form.getFieldValue(fieldName('additionalVisitInfo')) ?? '-'}
			</Form.Item>
			<Divider />
			<Form.Item
				name={fieldName('visitVerificationNotes')}
				label="Verification Notes"
				labelCol={{
					span: 6,
				}}
				rules={[rule.required()]}
			>
				<Input.TextArea rows={4} />
			</Form.Item>
			<Button
				type="primary"
				style={{
					width: 200,
					display: 'block',
					marginLeft: 'auto',
					marginTop: 20,
				}}
				onClick={() => {
					form.submit();
				}}
			>
				SAVE
			</Button>
		</Form>
	);
};

export default CCASiteVisitReportDetail;
